import { createContext } from 'react';

export const LoanCalculatorContext = createContext({
    fields: [],
    handleFieldChange: null,
    monthlySavings: 0,
    newMonthlyCost: 0,
    settings: null,
}) as any;
